/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new document. Images and videos are no longer accepted here; migrate those uploads to the claim Photos API.
 * @export
 * @interface CreateDocumentRequest
 */
export interface CreateDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentRequest
     */
    claimId: number;
    /**
     * Kind of document (insurer or contractor)
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    kind: CreateDocumentRequestKindEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    filename: string;
    /**
     * Supported document MIME type. Image and video MIME types are rejected; use the claim Photos API for media uploads.
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    mimeType: CreateDocumentRequestMimeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateDocumentRequest
     */
    sizeBytes: number;
    /**
     * Base64 encoded file content
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    fileContent: string;
    /**
     * Initial parsing status
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    parseStatus?: CreateDocumentRequestParseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentRequest
     */
    parseError?: string;
    /**
     * Whether to send upload notification (default false)
     * @type {boolean}
     * @memberof CreateDocumentRequest
     */
    notify?: boolean;
    /**
     * Optional folder ID to upload the document directly into a folder
     * @type {number}
     * @memberof CreateDocumentRequest
     */
    folderId?: number | null;
}


/**
 * @export
 */
export const CreateDocumentRequestKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type CreateDocumentRequestKindEnum = typeof CreateDocumentRequestKindEnum[keyof typeof CreateDocumentRequestKindEnum];

/**
 * @export
 */
export const CreateDocumentRequestMimeTypeEnum = {
    ApplicationPdf: 'application/pdf',
    ApplicationMsword: 'application/msword',
    ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ApplicationVndMsExcel: 'application/vnd.ms-excel',
    ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    TextPlain: 'text/plain'
} as const;
export type CreateDocumentRequestMimeTypeEnum = typeof CreateDocumentRequestMimeTypeEnum[keyof typeof CreateDocumentRequestMimeTypeEnum];

/**
 * @export
 */
export const CreateDocumentRequestParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type CreateDocumentRequestParseStatusEnum = typeof CreateDocumentRequestParseStatusEnum[keyof typeof CreateDocumentRequestParseStatusEnum];


/**
 * Check if a given object implements the CreateDocumentRequest interface.
 */
export function instanceOfCreateDocumentRequest(value: object): value is CreateDocumentRequest {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    if (!('fileContent' in value) || value['fileContent'] === undefined) return false;
    return true;
}

export function CreateDocumentRequestFromJSON(json: any): CreateDocumentRequest {
    return CreateDocumentRequestFromJSONTyped(json, false);
}

export function CreateDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'kind': json['kind'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'sizeBytes': json['sizeBytes'],
        'fileContent': json['fileContent'],
        'parseStatus': json['parseStatus'] == null ? undefined : json['parseStatus'],
        'parseError': json['parseError'] == null ? undefined : json['parseError'],
        'notify': json['notify'] == null ? undefined : json['notify'],
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
    };
}

export function CreateDocumentRequestToJSON(json: any): CreateDocumentRequest {
    return CreateDocumentRequestToJSONTyped(json, false);
}

export function CreateDocumentRequestToJSONTyped(value?: CreateDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'kind': value['kind'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
        'fileContent': value['fileContent'],
        'parseStatus': value['parseStatus'],
        'parseError': value['parseError'],
        'notify': value['notify'],
        'folderId': value['folderId'],
    };
}

